interface FooterColumnProps {
  title: string;
  className?: string;
  children: React.ReactNode;
}

export const FooterColumn = ({ title, className, children }: FooterColumnProps) => (
  <div className={`w-full md:w-48.75 ${className ?? ''}`}>
    <h4 className="font-bold text-footer-heading text-lg leading-tight font-raleway mb-2">
      {title}
    </h4>
    {children}
  </div>
);
